/**
 * @generated SignedSource<<0d7e1a97b5be6ce7f9d9ebf1f7a3d8ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTimelineIssueFragment$data = {
  readonly id: string;
  readonly repository: {
    readonly id: string;
    readonly nameWithOwner: string;
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"useTimelineItemsBackFragment" | "useTimelineItemsFrontFragment">;
  readonly " $fragmentType": "IssueTimelineIssueFragment";
};
export type IssueTimelineIssueFragment$key = {
  readonly " $data"?: IssueTimelineIssueFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineIssueFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueTimelineIssueFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useTimelineItemsFrontFragment"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "count",
          "value": 0
        }
      ],
      "kind": "FragmentSpread",
      "name": "useTimelineItemsBackFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "69e3b722cb70fcda50cde002214547ca";

export default node;
